/* @flow */

import { REHYDRATE } from 'redux-persist';
import { MARKDOWN_FILE_ACTIONS } from '../constants/actionTypes';

const init_state = {
    byId: {},
    allIds: []
};

export function byId(state = {}, action) {
    switch (action.type) {
        case MARKDOWN_FILE_ACTIONS.updated:
        case MARKDOWN_FILE_ACTIONS.received:
            return Object.assign({}, state, { [action.item.id]: action.item });

        case MARKDOWN_FILE_ACTIONS.invalidated:
            return Object.keys(state).reduce((result, key) => {
                if (key !== action.item.id) {
                    result[key] = state[key];
                }
                return result;
            }, {});

        default:
            return state;
    }
}

export function allIds(state = [], action) {
    switch (action.type) {
        case MARKDOWN_FILE_ACTIONS.received:
            if (state.indexOf(action.item.id) === -1) {
                return [...state, action.item.id];
            }
            return state;

        case MARKDOWN_FILE_ACTIONS.invalidated:
            return state.filter(id => id !== action.item.id);

        default:
            return state;
    }
}

export default function markdownFileReducer(state = init_state, action) {
    // 处理 redux-persist 的 REHYDRATE action
    if (action.type === REHYDRATE) {
        // 如果有持久化的 markdownFiles 数据，使用它
        if (action.payload && action.payload.markdownFiles) {
            return action.payload.markdownFiles;
        }
        // 否则返回当前状态
        return state;
    }

    return {
        byId: byId(state.byId, action),
        allIds: allIds(state.allIds, action)
    };
}